module.exports = __webpack_public_path__ + "resources/img/img_edb_1_m.c66d8d38aef8a431fcd60a62f749b1a3.png";